module.exports = __webpack_public_path__ + "03_bob_gold.5507001d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/03_bob_gold.png
// module id = zmP6
// module chunks = 0